import _isEmpty from 'lodash/isEmpty';
import i18n from './reacti18n';
import Page from './page';
import { bnaSectionTitleLimits, getDisplayName } from './messageHelper';
import { trackPage } from './analytics-helper';
import UrlResources from '../home/constants/UrlResources';
import getHistory from './HistoryHelper';

const getNNAConfig = () => {
  try {
    if (window && window.nnaConfig) {
      return window.nnaConfig;
    }
    return {};
  } catch (e) {
    return {};
  }
};

export const getNNAWidgetTitle = () => {
  const displayName = getDisplayName();
  if (!_isEmpty(displayName)) {
    const nnaUserTitle = i18n.message('smarthelp/home.home.NNA.welcomeUser', { name: displayName });
    if (nnaUserTitle.length <= bnaSectionTitleLimits[Page.getDeviceType()]) {
      return nnaUserTitle;
    }
  }
  return i18n.message('smarthelp/home.home.forYou');
};

export const redirectNnaToICFUrl = () => {
  try {
    const nnaConfig = getNNAConfig();
    if (nnaConfig && nnaConfig.icfId) {
      return getHistory().push(`/${UrlResources.PAYPALGUIDE}/${nnaConfig.icfId}`);
    }
    return trackPage({ id: 'nnaHomePageError', link: 'smarthelp-home-nna-widget|icf-redirect-failure' });
  } catch (e) {
    return trackPage({ id: 'nnaHomePageError', link: 'smarthelp-home-nna-widget|icf-redirect-failure' });
  }
};

export const getNNAIcfId = () => {
  const nnaConfig = getNNAConfig();
  return nnaConfig.icfId || '';
};
